// BANGUOJA: swipe nuotraukos produkto kortelėje – aktyvus taškelis pagal slinkimo poziciją (žr. snippets/bj-card-swipe.liquid).
// Vienas klausytojas visam puslapiui (capture), todėl veikia ir po kolekcijos filtravimo / „rodyti daugiau“.
if (!window.bjCardSwipe) {
  window.bjCardSwipe = true;

  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (!track || !track.classList || !track.classList.contains('bj-swipe__track')) return;

    const width = track.clientWidth;
    if (!width) return;

    const index = Math.round(track.scrollLeft / width);
    const dots = track.parentElement.querySelectorAll('.bj-swipe__dot');
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }, { capture: true, passive: true });
}
